import {Directive, EventEmitter, Output} from '@angular/core';

@Directive({
  selector: '[ngInit]',
  standalone: true,
})
export class NgInitDirective {

  @Output('ngInit') initEvent: EventEmitter<any> = new EventEmitter();

  ngOnInit() {
    setTimeout(() => this.initEvent.emit(), 10);
  }
}
